import _ from 'lodash';
import utils from 'lib/utils';
import qs from 'query-string';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchList = async (params = {}) => {
  try {
    const qs = reqTransform.fetchList(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/OpenBuySell/GetRemarks?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchList(resData);
  } catch (err) {
    console.log('api-OpenBuySell-GetRemarks->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'GetRemarks');
    throw errors;
  }
};

export const update = async (params = {}) => {
  try {
    let bodyParams = reqTransform.update(params);

    const url = `${baseUrl}/BioFuelRequirementOffers/api/OpenBuySell/UpdateRemarks`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.update(resData);
  } catch (err) {
    console.log('UpdateRemarks-update->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'UpdateRemarks');
    throw errors;
  }
};
